import { Helmet } from 'react-helmet-async';
import { BASE_URL, OG_IMAGE } from '../utils/seo';
import { HeroSection } from '../components/home/HeroSection';
import { PainSection } from '../components/home/PainSection';
import { OtherSideSection } from '../components/home/OtherSideSection';
import { TwoClientTypes } from '../components/home/TwoClientTypes';
import { WhoElseSection } from '../components/home/WhoElseSection';
import { CredibilitySnapshot } from '../components/home/CredibilitySnapshot';
import { ProgramSnapshot } from '../components/home/ProgramSnapshot';
import { PageCTA } from '../components/PageCTA';

export default function Home() {
    return (
        <div data-testid="home-page">
            <Helmet>
                <title>White Glove Hiring - Precision VA Hiring & Long-Term Oversight</title>
                <meta name="description" content="White Glove Hiring places high-caliber VAs and installs the systems to keep them on track. $900/month. For real estate agents and industry professionals." />
                <meta property="og:title" content="White Glove Hiring - Precision VA Hiring & Long-Term Oversight" />
                <meta property="og:description" content="Most agents don't have a production problem - they have a leverage problem. White Glove Hiring fixes that." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content={`${BASE_URL}/`} />
                <meta property="og:image" content={OG_IMAGE} />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="White Glove Hiring - Precision VA Hiring & Long-Term Oversight" />
                <meta name="twitter:description" content="Most agents don't have a production problem - they have a leverage problem. White Glove Hiring fixes that." />
                <meta name="twitter:image" content={OG_IMAGE} />
                <link rel="canonical" href={`${BASE_URL}/`} />
            </Helmet>
            <HeroSection />
            <PainSection />
            <OtherSideSection />
            <TwoClientTypes />
            <WhoElseSection />
            <CredibilitySnapshot />
            <ProgramSnapshot />
            <PageCTA
                headline="You've Earned a Business That Works Without You."
                sub="One conversation. No pressure. We'll tell you exactly what we'd build and why."
                testId="home-footer-cta"
            />
        </div>
    );
}
